s-accordion-contained {
  > .accordion-contained-header {
    align-items: flex-start;
    border: 1px solid var(--color-gray-light);
    border-radius: 4px 4px 0 0;
    display: flex;
    justify-content: space-between;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      margin: 0;
    }

    .subtitle {
      color: var(--color-gray-dark);
      font-weight: var(--font-weight-semibold);
    }
  }

  .accordion-container {
    s-accordion-stacked {
      > details {
        border-left: 1px solid var(--color-gray-light);
        border-right: 1px solid var(--color-gray-light);
        * {
          box-sizing: border-box;
        }
      }

      &:first-of-type > details > summary {
        border-top: 0;
      }
      &:last-of-type details {
        border-radius: 0 0 4px 4px;
      }
    }
  }

  @media only screen and (max-width: 839px) {
    > .accordion-contained-header,
    .accordion-container > s-accordion-stacked > details > summary {
      padding: var(--padding-sm) var(--padding-sm);
    }
    .accordion-container > s-accordion-stacked > details > summary + * {
      padding: 0 var(--padding-sm);
    }
  }

  @media only screen and (min-width: 840px) and (max-width: 1259px) {
    > .accordion-contained-header,
    .accordion-container > s-accordion-stacked > details > summary {
      padding: var(--padding-sm) var(--padding-lg);
    }
    .accordion-container > s-accordion-stacked > details > summary + * {
      padding: 0 var(--padding-lg);
    }
  }

  @media only screen and (min-width: 1260px) {
    > .accordion-contained-header,
    .accordion-container > s-accordion-stacked > details > summary {
      padding: var(--padding-sm) var(--padding-xl);
    }
    .accordion-container > s-accordion-stacked > details > summary + * {
      padding: 0 var(--padding-xl);
    }
  }
}
